import type { CSSProperties, ReactNode } from 'react'
import { PRIORITY_LABEL, type DecisionPriority } from './decisionSystem'

const PRIORITY_STYLE: Record<DecisionPriority, CSSProperties> = {
  critical: { color: 'var(--danger)', background: 'var(--danger-soft)', borderColor: 'var(--danger)' },
  high: { color: 'var(--warning)', background: 'var(--warning-soft)', borderColor: 'var(--warning)' },
  opportunity: { color: 'var(--positive)', background: 'var(--accent-soft)', borderColor: 'var(--positive)' },
  watch: { color: 'var(--slate)', background: 'var(--surface-3)', borderColor: 'var(--slate)' },
  healthy: { color: 'var(--positive)', background: 'var(--accent-soft)', borderColor: 'var(--positive)' },
  'insufficient-data': { color: 'var(--text-2)', background: 'var(--surface-3)', borderColor: 'var(--border-2)' },
}

interface PriorityBadgeProps {
  priority: DecisionPriority
  children?: ReactNode
  className?: string
}

/** Priority is communicated by label + shape + color, never color alone. */
export function PriorityBadge({ priority, children, className }: PriorityBadgeProps) {
  return (
    <span
      className={className}
      data-priority={priority}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        width: 'fit-content',
        padding: '3px 8px',
        border: '1px solid',
        borderRadius: 'var(--r-xs)',
        fontFamily: 'var(--mono)',
        fontSize: 9,
        fontWeight: 700,
        letterSpacing: '0.08em',
        lineHeight: 1.4,
        textTransform: 'uppercase',
        ...PRIORITY_STYLE[priority],
      }}
    >
      {children ?? PRIORITY_LABEL[priority]}
    </span>
  )
}
